import React from 'react';

const WhySection = () => {
  return (
    <section className="why-section">
      <div className="why-inner">
        <div>
          <p className="section-eyebrow">The Problem</p>
          <h2 className="section-title">Most founders sell <em>once.</em><br />Buyers do this every day.</h2>
          <p className="section-intro">The information and experience gap between a first-time seller and a professional buyer team is enormous — and it shows up directly in your final number.</p>
        </div>
        <div className="pain-points">
          <div className="pain-point">
            <span className="pain-num">01</span>
            <div className="pain-text">
              <strong>The Experience Gap</strong>
              <p>You've sold a company once. Maybe twice. The buyer's M&A team has done this hundreds of times with refined playbooks and specialists at every stage.</p>
            </div>
          </div>
          <div className="pain-point">
            <span className="pain-num">02</span>
            <div className="pain-text">
              <strong>The Preparation Gap</strong>
              <p>Most founders begin preparing when a buyer appears. By then, leverage is already shifting. Premium valuations are built 12–24 months before the first meeting.</p>
            </div>
          </div>
          <div className="pain-point">
            <span className="pain-num">03</span>
            <div className="pain-text">
              <strong>The Knowledge Gap</strong>
              <p>Earn-outs, working capital pegs, reps and warranties, QoE reports — terms that profoundly affect your payout, encountered for the first time mid-deal.</p>
            </div>
          </div>
          <div className="pain-point">
            <span className="pain-num">04</span>
            <div className="pain-text">
              <strong>The Execution Gap</strong>
              <p>Knowing what to do and having a system to do it are different things. ValueARC is both — the knowledge and the operating platform to execute on it.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
